import React, { useState, useRef } from 'react';
import { Button, Form } from 'react-bootstrap';
import { FaTimes } from 'react-icons/fa';
import useClickOutside from '../hooks/useClickOutside';

interface IAutocompleteInput {
    placeholder?: string;
    label?: string;
    value: string;
    items: any[];
    renderItems: string[];
    highlightKeys?: string[];
    hasClearBtn?: boolean;
    setFilter: (value: string) => void;
    onSelect: (value: any) => void;
    clearFunc?: () => void;
    classes?: string;
    keyState?: string;
    keyItemSelect?: string;
    notRememberFilter?: boolean;
}

export default function AutocompleteInput({
    placeholder,
    label,
    value,
    items,
    renderItems,
    highlightKeys,
    hasClearBtn,
    setFilter,
    onSelect,
    clearFunc,
    classes,
    keyState,
    keyItemSelect,
    notRememberFilter,
}: IAutocompleteInput) {
    const [showSuggestions, setShowSuggestions] = useState(false);
    const wrapperRef = useRef<HTMLDivElement>(null);

    useClickOutside(wrapperRef, () => {
        setShowSuggestions(false);
    });

    const handleSelect = (item: any) => {
        if (!keyState || !keyItemSelect) {
            onSelect(item);
        } else {
            onSelect((prev: any) => ({ ...prev, [keyState]: item[keyItemSelect] }));
        }
        if (!notRememberFilter) {
            const name = renderItems
                .map((key: string) => (item?.[key] ? item[key] + ' ' : highlightKeys?.includes(key) ? '' : '-'))
                .join('');
            setFilter(name);
        }
        setShowSuggestions(false);
    };

    return (
        <div className={`autocomplete-input position-relative ${classes ?? ''}`} ref={wrapperRef}>
            {label && (
                <label htmlFor={`autocomplete${label}`} className="d-block font-size-h6">
                    {label}
                </label>
            )}
            <div className="d-flex position-relative w-100">
                <Form.Control
                    type="text"
                    placeholder={placeholder}
                    value={value}
                    onChange={e => {
                        setFilter(e.target.value);
                        setShowSuggestions(true);
                    }}
                    onFocus={() => setShowSuggestions(true)}
                    autoComplete="off"
                />
                {hasClearBtn && value && (
                    <Button
                        variant=""
                        className="py-2 px-3 clearBtn btn-hover-bg-secondary"
                        onClick={() => {
                            clearFunc?.();
                            setShowSuggestions(false);
                        }}
                    >
                        <FaTimes fontSize={14} />
                    </Button>
                )}

                {showSuggestions && items?.length > 0 && (
                    <div
                        className="suggestion-wrapper position-absolute bg-white border rounded w-100 mt-1 zindex-dropdown shadow-sm"
                        style={{ overflowY: 'auto' }}
                    >
                        {items.map((item: any, index: number) => (
                            <div
                                key={index}
                                className="px-3 py-2 autocomplete-item hover-bg-light cursor-pointer"
                                onClick={() => handleSelect(item)}
                            >
                                {renderItems.map(key =>
                                    highlightKeys?.includes(key) ? (
                                        item[key] && (
                                            <span key={key} className="text-primary">
                                                {item[key]}
                                            </span>
                                        )
                                    ) : (
                                        <span key={key}>{item[key] ? item[key] + ' ' : '-'}</span>
                                    )
                                )}
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
}
